module.exports = __webpack_public_path__ + "static/media/show3.2bc631ca.png";